import { useEffect, useState } from 'react';

import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

const URL_MAP = {
  getResource: () => `${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/node/resource-sorts`,
  getNodes: () => `${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/available-nodes`,
  getArchs: () => `${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/node/config`,
};

export function getResource() {
  return get(URL_MAP.getResource());
}

export function getNodeList(params: Record<string, unknown>) {
  return get(URL_MAP.getNodes(), params);
}

/** 按 URL 复用进行中的请求，避免同页多处重复打 node/config */
let _nodeConfigCache: { url: string; promise: Promise<unknown> } | null = null;

export function getNodeConfig() {
  const url = URL_MAP.getArchs();
  if (_nodeConfigCache?.url === url) return _nodeConfigCache.promise;
  const promise = get(url).catch((error) => {
    if (_nodeConfigCache?.promise === promise) _nodeConfigCache = null;
    throw error;
  });
  _nodeConfigCache = { url, promise };
  return promise;
}

export function useResourceQuery() {
  const [queryObj, setQueryObj] = useState<any>({});

  useEffect(() => {
    getResource()
      .then((res: any) => setQueryObj(res))
      .catch(console.error);
  }, []);

  return queryObj;
}
